
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { ClipboardCheck } from 'lucide-react';

interface DryRunResultsProps {
  dryRunResults: {
    certificates_count?: number;
    state_breakdown?: Record<string, number>;
  } | null;
}

export function DryRunResults({ dryRunResults }: DryRunResultsProps) {
  if (!dryRunResults) {
    return null;
  }

  return (
    <Alert variant="default">
      <ClipboardCheck className="h-4 w-4" />
      <AlertTitle>Dry Run Results</AlertTitle>
      <AlertDescription>
        <div className="space-y-2 mt-2">
          <p><strong>{dryRunResults.certificates_count || 0}</strong> certificates would be archived</p>
          {dryRunResults.state_breakdown && (
            <div>
              <p className="text-sm font-medium">Breakdown by state:</p>
              <ul className="text-sm pl-4 space-y-1">
                {Object.entries(dryRunResults.state_breakdown).map(([state, count]) => (
                  <li key={state}>{state}: {String(count)} certificates</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </AlertDescription>
    </Alert>
  );
}
